export const REQUESTED_HISTORICAL_BALANCES = 'REQUESTED_HISTORICAL_BALANCES';
export const RECEIVED_HISTORICAL_BALANCES = 'RECEIVED_HISTORICAL_BALANCES';
export const ERROR_HISTORICAL_BALANCES = 'ERROR_HISTORICAL_BALANCES';
export const RESET_HISTORICAL_BALANCES = 'RESET_HISTORICAL_BALANCES';
export const HISTORICAL_BALANCES_SUFFIX = 'HISTORICAL_BALANCES';

export const requestedHistoricalBalances = (selectedDate = null) => ({
  type: REQUESTED_HISTORICAL_BALANCES,
  selectedDate
});

export const receivedHistoricalBalances = (balances = null) => ({
  type: RECEIVED_HISTORICAL_BALANCES,
  balances
});

export const errorHistoricalBalances = () => ({
  type: ERROR_HISTORICAL_BALANCES
});

export const resetHistoricalBalances = () => ({
  type: RESET_HISTORICAL_BALANCES
});
